export enum AccountingSubType {
  invoice = "Invoice",
  creditNote = "Credit-Note",
  debitNote = "Debit-Note",
}

export enum AccountingType {
  credit = "Credit",
  debit = "Debit",
}

export enum AccountingPaymentStatus {
  paid = "Paid",
  partiallyPaid = "Partially-Paid",
  pending = "Pending",
  cnIssued = "CN-Issued",
}

export const INVOICES_QUERY_KEY = ["invoices"];
export const PURCHASES_QUERY_KEY = ["purchases"];
